export interface WorkspaceOrganizations {
  created_at: string;
  updated_at: string;
  created_by_id: string;
  last_updated_by_id: string;
  name: string;
  address?: string;
  city?: string;
  state?: string;
  country: string;
  zip_code?: string;
  place_id: unknown;
  source: string;
  currency: string;
  unit_system: string;
  phone: unknown;
  email?: string;
  employer_identification_number: unknown;
  picture_url: string;
  deleted: boolean;
  reference_point: unknown;
  licensing_account_id: string;
  workspace_id: string;
  crn: string;
  id: string;
}

interface Pageable {
  sort: {
    sorted: boolean;
    unsorted: boolean;
    empty: boolean;
  };
  page_number: number;
  page_size: number;
  offset: number;
  paged: boolean;
  unpaged: boolean;
}

export type WorkspacePageable = {
  content: Array<WorkspaceOrganizations>;
  pageable: Pageable;
  total_elements: number;
  total_pages: number;
  last: boolean;
  first: boolean;
  sort: {
    sorted: boolean;
    unsorted: boolean;
    empty: boolean;
  };
  number: number;
  number_of_elements: number;
  size: number;
  empty: boolean;
};

export interface Workspace {
  id: string;
  name: string;
}

export interface WorkspaceOrg {
  id: string;
  name: string;
}

export interface WorkspaceState {
  entities: Workspace[];
  selected: Workspace | null;
  loading: boolean;
  error: string | null;
  orgs: WorkspaceOrg[];
  orgsLoading: boolean;
  orgsError: string | null;
  orgsWorkspaceId: string | null;
}

export const initialWorkspaceState: WorkspaceState = {
  entities: [],
  selected: null,
  loading: false,
  error: null,
  orgs: [],
  orgsLoading: false,
  orgsError: null,
  orgsWorkspaceId: null
};
